/**
 * Dónde escribe el dueño durante la entrevista.
 *
 * Extraído de `Conversacion.tsx` al agregarle el turno de la voz (GKTIBO-122),
 * que la empujaba por encima de las 300 líneas (D4). No es sólo contar
 * renglones: el redactor es la pieza que **se apaga** en un caso concreto, y
 * tenerla aparte hace que ese caso se vea.
 *
 * ## Por qué se apaga
 *
 * Mientras la tarjeta de la voz espera respuesta, el campo queda deshabilitado.
 * Si no, lo que el dueño escribiera se rutearía al tema `voz` —que la ruta
 * rechaza a propósito con 400 (GKTIBO-121)— y él vería un error sin entender
 * qué hizo mal. El camino que no existe se cierra antes, no se explica después.
 */

import { Button } from '../../components/ui/Button';
import { textos } from './textos';
import { entrevista } from './textos-entrevista';

export interface RedactorDeLaEntrevistaProps {
  texto: string;
  onTexto: (texto: string) => void;
  onEnviar: () => void;
  /** El modelo está pensando: no se manda dos veces. */
  pensando: boolean;
  /** Hay una tarjeta esperando y el texto libre no tiene dónde ir. */
  apagado: boolean;
}

export function RedactorDeLaEntrevista({
  texto,
  onTexto,
  onEnviar,
  pensando,
  apagado,
}: RedactorDeLaEntrevistaProps) {
  const t = entrevista.chat;

  return (
    <form
      className="alta-chat-redactor"
      onSubmit={(e) => {
        e.preventDefault();
        onEnviar();
      }}
    >
      <label className="sr-only" htmlFor="alta-chat-entrada">
        {textos.conocimiento.titulo}
      </label>
      <textarea
        id="alta-chat-entrada"
        value={texto}
        rows={1}
        placeholder={t.escribi}
        disabled={apagado}
        onChange={(e) => onTexto(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onEnviar();
          }
        }}
      />
      <Button type="submit" disabled={texto.trim().length === 0 || pensando || apagado}>
        {t.enviar}
      </Button>
    </form>
  );
}
